import React, { useEffect, useState } from 'react';
import './CardsCantidad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faUser, 
    faBook, 
    faImage, 
    faAddressBook, 
    faTachometerAlt, 
    faCode, 
    faCalendarAlt,
    faMapMarkerAlt,
    faArrowRight,
    faCog
} from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import baseURL from '../../url';
import useAuthUser from '../../useAuthUser';

export default function CardsCantidad() {
    const { isAdmin } = useAuthUser();
    const [productos, setProductos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [banners, setBanners] = useState([]);
    const [categorias, setCategoras] = useState([]);
    const [contactos, setContactos] = useState([]);
    const [codigos, setCodigos] = useState([]);
    const [eventos, setEventos] = useState([]);
    const [centros, setCentros] = useState([]);

    useEffect(() => {
        cargarProductos();
        cargarUsuarios();
        cargarBanners();
        cargarCategoria();
        cargarContacto();
        cargarCodigos();
        cargarEventos();
        cargarCentros();
    }, []);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, { method: 'GET' })
            .then(res => res.json())
            .then(data => setProductos(data.productos || []))
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarUsuarios = () => {
        fetch(`${baseURL}/usuariosGet.php`, { method: 'GET', credentials: 'include' })
            .then(res => res.json())
            .then(data => setUsuarios(data.usuarios || []))
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const cargarEventos = () => {
        fetch(`${baseURL}/eventosGet.php`, { method: 'GET' })
            .then(res => res.json())
            .then(data => setEventos(data.eventos || []))
            .catch(error => console.error('Error al cargar eventos:', error));
    };

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, { method: 'GET' })
            .then(res => res.json())
            .then(data => setBanners(data.banner || []))
            .catch(error => console.error('Error al cargar banners:', error));
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, { method: 'GET' })
            .then(res => res.json())
            .then(data => setCategoras(data.categorias || []))
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
            .then(res => res.json())
            .then(data => setContactos(data.contacto || []))
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarCodigos = () => {
        fetch(`${baseURL}/codigosGet.php`, { method: 'GET' })
            .then(res => res.json())
            .then(data => setCodigos(data.codigos || []))
            .catch(error => console.error('Error al cargar códigos:', error));
    };

    const cargarCentros = () => {
        fetch(`${baseURL}/centrosServiciosGet.php`, { method: 'GET', credentials: 'include' })
            .then(res => res.json())
            .then(data => setCentros(data.centros || []))
            .catch(error => console.error('Error al cargar centros:', error));
    };

    const metricas = [
        { title: 'Usuarios', count: usuarios.length, path: '/dashboard/usuarios', icon: faUser, colorClass: 'cardIconPurple', adminOnly: true },
        { title: 'Productos', count: productos.length, path: '/dashboard/productos', icon: faBook, colorClass: 'cardIconIndigo' },
        { title: 'Categorías', count: categorias.length, path: '/dashboard/categorias', icon: faTachometerAlt, colorClass: 'cardIconBlue' },
        { title: 'Eventos', count: eventos.length, path: '/dashboard/eventos', icon: faCalendarAlt, colorClass: 'cardIconEmerald' },
        { title: 'Centros', count: centros.length, path: '/dashboard/centros-servicios', icon: faMapMarkerAlt, colorClass: 'cardIconAmber' },
        { title: 'Banners', count: banners.length, path: '/dashboard/banners', icon: faImage, colorClass: 'cardIconRose' },
        { title: 'Contactos', count: contactos.length, path: '/dashboard/contacto', icon: faAddressBook, colorClass: 'cardIconCyan' },
        { title: 'Códigos', count: codigos.length, path: '/dashboard/codigos', icon: faCode, colorClass: 'cardIconViolet' },
        { title: 'Identidad & SEO', count: 'Colores & Web', path: '/dashboard/configuracion', icon: faCog, colorClass: 'cardIconIndigo', adminOnly: true },
    ];

    const metricasVisibles = metricas.filter(item => !item.adminOnly || isAdmin);

    return (
        <div className='CardsCantidad'>
            {metricasVisibles.map((item, index) => (
                <Anchor to={item.path} key={index} className='cardCantidad'>
                    <div className={`iconWrapper ${item.colorClass}`}>
                        <FontAwesomeIcon icon={item.icon} className='icons' />
                    </div>
                    <div className='deColumn'>
                        <span className='cardTitle'>{item.title}</span>
                        <h2 className='cardNumber'>{item.count}</h2>
                    </div>
                    <span className='cardArrow'>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                </Anchor>
            ))}
        </div>
    );
}
